var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelenium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#01A71C;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Selenium"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.6,51.6c-1.9,0-3.5,1.4-3.8,3.2c0,0,0,0.1,0,0.1l0,0h7.3c0.1,0,0.1-0.1,0.1-0.1l0,0 C76.1,53,74.5,51.6,72.6,51.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.2,27.2L72.8,44.6c-0.2,0.2-0.5,0.2-0.7,0l0,0l-7.9-8.1c-0.2-0.2-0.2-0.4,0-0.6l2.6-3.3 c0.1-0.2,0.4-0.3,0.7-0.1c0,0,0,0,0,0c0,0,0.1,0.1,0.1,0.1l4.4,4.9c0.2,0.2,0.5,0.2,0.7,0c0,0,0,0,0,0l0,0L85,20.5 c0.1-0.2,0.1-0.4-0.1-0.5c-0.1,0-0.1,0-0.2,0H41.5c-0.2,0-0.4,0.2-0.4,0.4v49.3c0,0.2,0.2,0.4,0.4,0.4c0,0,0,0,0,0h47 c0.2,0,0.4-0.1,0.4-0.3c0,0,0,0,0,0V27.5c0.1-0.2,0-0.4-0.2-0.5C88.5,27,88.3,27.1,88.2,27.2z M54.4,64.5 c-3.1,0.2-6.1-0.9-8.4-2.9c-0.2-0.2-0.2-0.4,0-0.6l1.9-2.6c0.1-0.2,0.4-0.3,0.6-0.2c0,0,0,0,0,0l0,0c1.7,1.6,3.9,2.4,6.2,2.4 c2.4,0,3.6-1.1,3.6-2.3c0-3.8-11.9-1.1-11.9-8.9c0-3.4,2.9-6.3,7.8-6.3c2.8-0.1,5.5,0.8,7.7,2.6c0.2,0.2,0.2,0.5,0,0.6L60,48.9 c-0.2,0.2-0.5,0.2-0.6,0c0,0,0,0,0,0l0,0c-1.6-1.2-3.6-1.9-5.6-1.9c-1.9,0-2.9,0.8-2.9,2.1c0,3.3,11.9,1.1,11.9,8.8 C62.7,61.7,60,64.5,54.4,64.5L54.4,64.5z M80.3,57.4c0,0.2-0.2,0.4-0.4,0.4c0,0,0,0,0,0H69c0,0-0.1,0-0.1,0.2l0,0 c0.4,2.1,2.3,3.6,4.4,3.4c1.3,0,2.7-0.5,3.8-1.2c0.2-0.1,0.4-0.1,0.6,0l0,0l1.3,1.9c0.1,0.2,0.1,0.4,0,0.5c-1.8,1.3-3.9,1.9-6,1.9 c-4.3,0.2-7.9-3-8.2-7.3c0-0.2,0-0.5,0-0.8c-0.1-4.3,3.2-7.9,7.5-8h0.4c4.6,0,7.7,3.4,7.7,8.4L80.3,57.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelenium);
export default __webpack_public_path__ + "static/media/Selenium.c6b91413ca5bb92212b2e2c9b6438442.svg";
export { ForwardRef as ReactComponent };